<template>
  <div class="bubble">
    <div class="growSpacer"></div>
    <b-button
      style="background: none; color: #dfdfdf; border: none; font-size: 24px"
      @click="go"
      >{{ name }}</b-button
    >
    <div class="growSpacer"></div>
  </div>
</template>

<script>
import { getAttributes } from "@/common/character/attributes.ts";
import { getDetails } from "@/common/character/details.ts";
import { getBuild } from "@/common/character/build.ts";
import {
  getPairs,
  getAdventureColor,
  getCharacterColor,
  postAdventureColor,
} from "@/common/adventure/adventure.ts";

export default {
  name: "AdventureNav",
  props: {
    id: { type: Number, default: 0 },
    name: { type: String, default: "Crescent Adventure" },
  },
  computed: {
    adventureCharacters() {
      return this.$store.getters["adventureCharacters"];
    },
  },
  methods: {
    go: async function () {
      //this.$store.commit("adventure/overview/setName", this.name);
      // await getPairs(this.id).then((response) => {
      //   this.$store.commit("setAdventureCharacters", response.data.pairs);
      // });

      // try {
      //   const response = await getAdventureColor(this.id);
      //   this.$store.commit(
      //     "adventure/designDetails/setAdventureDesignState",
      //     response.data.color_scheme_adv
      //   );
      // } catch (err) {
      //   await postAdventureColor(this.id, {
      //     pageBackground: "#dfdfdf",
      //     textShade1: "#dfdfdf",
      //     textShade2: "#000000",
      //     componentBacking: "#422c58",
      //     inputBacking: "#f1eef1",
      //     alertShade: "#c15be6",
      //     font: "Bahnschrift",
      //   });
      // }

      // const response = await getCharacterColor(this.id);
      // this.$store.commit(
      //   "adventure/designDetails/setAdventureCharacterDesignState",
      //   response.data.character_schemes[0]
      // );

      // await this.init();
      await this.$router.push("/adventure/" + this.id);
    },
    async init() {
      for (const character of this.adventureCharacters) {
        let attrs = await this.populateAttributes(character);
        let name = await this.getDetails(character);
        let build = await this.getBuild(character);
        let newData = {
          id: character,
          name: name,
          agility: attrs.agility,
          charisma: attrs.charisma,
          health: attrs.health,
          intelligence: attrs.intelligence,
          perception: attrs.perception,
          power: attrs.power,
          strength: attrs.strength,
          willpower: attrs.willpower,
          maxHp: build.maxHp,
          currentHp: build.currentHp,
          maxMana: build.maxMana,
          currentMana: build.currentMana,
          mp: build.mp,
          armorDvs: build.armorDvs,
          shieldDvs: build.shieldDvs,
          moveDvs: build.moveDvs,
          bonusDvs: build.bonusDvs,
          level: build.level,
        };
        this.$store.commit(
          "adventure/characters/addCharacterToAdventure",
          newData
        );
      }
    },
    populateAttributes: async function (id) {
      const response = await getAttributes(id);
      if (response.data) {
        let attributes = response.data;
        return {
          agility: attributes.temp_agility,
          charisma: attributes.temp_charisma,
          health: attributes.temp_health,
          intelligence: attributes.temp_intelligence,
          perception: attributes.temp_perception,
          power: attributes.temp_power,
          strength: attributes.temp_strength,
          willpower: attributes.temp_willpower,
        };
      }
    },
    getDetails: async function (id) {
      const response = await getDetails(id);
      if (response.data) {
        return response.data.name;
      }
    },
    getBuild: async function (id) {
      const response = await getBuild(id);
      if (response.data) {
        return {
          maxHp: response.data.hp_max,
          currentHp: response.data.hp,
          maxMana: response.data.mana_max,
          currentMana: response.data.mana,
          mp: response.data.martial_points,
          armorDvs: response.data.defense_values_armor,
          shieldDvs: response.data.defense_values_shield,
          moveDvs: response.data.defense_values_movement,
          bonusDvs: response.data.defense_values_bonus,
          level: Math.floor(response.data.ability_points_total / 10),
        };
      }
    },
  },
};
</script>

<style scoped>
a {
  color: #dfdfdf;
  font-size: 24px;
}
div.bubble {
  display: flex;
  flex-direction: column;
  height: 200px;
  width: 200px;
  border-radius: 20px;
  background: #422c58;
  color: #dfdfdf;
}
div.growSpacer {
  height: 10px;
  width: 10px;
  flex-grow: 1;
}
</style>
